import wrapInObserver from '../../wrapInObserver';
import ReadyForEtrnBanner from './ReadyForEtrnBanner';
import ReadyForEtrnBannerMobile from './ReadyForEtrnBannerMobile';
import logger from '../../../logger';
import generatedHooks from '../../../hooks/generatedHooks';

import { makeEtrnLandingUrl } from '../../../utils/urlProvider';
import BannerStore from '../../../stores/bannerStore';

const { useBannerStore } = generatedHooks;

const mapProps = () => {
  try {
    const bannerStore = useBannerStore(store => store);

    return {
      readyForEtrnUrl: makeEtrnLandingUrl(),
      closeBanner: bannerStore.putReadyForEtrnBannerViewedFlag,
      imageUrl: bannerStore.banners[BannerStore.BANNER_TYPES.ETRN].imageUrl,
    };
  } catch (error) {
    logger.error(error, { sentryMessage: 'Error while rendering ReadyForEtrnBanner' });
    return {};
  }
};

export default wrapInObserver(ReadyForEtrnBanner, mapProps, ReadyForEtrnBannerMobile);
